import RouteHelper from '@/views/maps/ContainersPaths/RouteHelper.js'
import LinePointPopup from '@/views/maps/ContainersPaths/LinePointPopup.vue'
import Vue from 'vue'
import L from 'leaflet'
import start from '@/assets/icons/pin.png'

export default class Path {

  initPopup = {}
  routeLine = null
  path_points = []
  containers = []
  tags = []
  circles = []
  indices = [] // containers indices on the line
  green_indices = []
  segments = []
  lines = {}

  path_color = '#fa05f4'
  green_path_color = '#00ff0e'
  path_weight = 18
  green_path_weight = 18
  opacity = 0.3

  containersGroup = L.layerGroup()
  pathGroup = L.layerGroup()

  containerCircleOptions = {
    renderer: L.canvas({ padding: 0.5 }),
    fill: true,
    fillOpacity: 0.9,
    stroke: false,
    radius: 7,
  }

  pathOptions = {
    weight: this.green_path_weight,
    fillOpacity: this.opacity,
    opacity: 0.4,
    color: this.green_path_color,
    lineCap: "square"
  }

  linePointInfo = Vue.extend(LinePointPopup)

  selectedContainerFit = null

  constructor(map, routePoints, containersPoints, tags, lineData) {

    this.map = map
    this.containers = containersPoints
    this.tags = tags
    this.path_points = routePoints

    for (const i in this.containers) {
      const index = this.containerProjection(this.containers[i])
      this.indices.push(index)
    }

    this.initPopup = {
      id: lineData.id,
      path: lineData.pathName,
      device: lineData.device,
      owner: lineData.owner,
      contract: lineData.contract,
      count: this.indices.length,
      linelastupdate: '',
    }


    this.drawPath()
    this.segmentation()

    for (const i in this.containers) {
      const container =  this.createContainers(
        this.containers[i],
      );

      this.circles.push(container)

      container.on('click', () => {
        container.setPopupContent(
          this.initLinePointPopup({
              ...this.initPopup,
              ...this.tags[i]
            })
        )
      })

    }

    this.pathGroup.addLayer(this.containersGroup)
    this.pathGroup.addTo(this.map)

    console.log("lines:", this.lines)

    console.log("indices:", this.indices)
    console.log("segments:", this.segments)
  }

  prevIsGreen(i, segments) {
    let j = parseInt(i-1)
    while (this.green_indices.includes(j)) {
      segments.push(j)
      j--
    }

    this.pathGroup.removeLayer(this.lines[i-1])
    delete this.lines[i-1]
  }

  nextIsGreen(i, segments) {
    let j = parseInt(i+1)
    while (this.green_indices.includes(j)) {
      segments.push(j)
      j++
    }

    this.pathGroup.removeLayer(this.lines[j-1])
    delete this.lines[j-1]
  }

  readContainer({ tag, lastupdate }) {

    const i = this.tags.findIndex(item => item.tag === tag)
    if (i === -1) return

    this.tags[i].lastupdate = lastupdate
    this.circles[i].setPopupContent(this.initLinePointPopup(this.tags[i]))

    if (this.green_indices.includes(i)) return

    console.log("i: ", i)

    this.circles[i].setStyle({color: 'green', radius:9})

    if (this.green_indices.includes(i-1) || this.green_indices.includes(i+1)) {

      let segments = [i]
      if (this.green_indices.includes(i-1)) this.prevIsGreen(i, segments)
      if (this.green_indices.includes(i+1)) this.nextIsGreen(i, segments)

      segments.sort((a, b) => a - b);

      let a = []
      for (let k = 0; k < segments.length; k++) {
        a.push(this.segments[segments[k]])
      }

      const line = L.polyline(a, this.pathOptions)
      this.pathGroup.addLayer(line)
      this.lines[segments[segments.length - 1]] = line
      this.green_indices.push(parseInt(i))
    }

    else
    {
      const line = L.polyline(this.segments[i], this.pathOptions)
      this.pathGroup.addLayer(line)
      this.lines[i] = line
      this.green_indices.push(parseInt(i))
    }
  }

  segmentation() {

    let combined = this.indices.map((value, index) => ({
      value: value,
      coordinates: this.containers[index],
      data: this.tags[index]
    }));

    combined = combined.filter(item => item.value !== false);
    combined.sort((a, b) => a.value - b.value);

    this.indices = combined.map(item => item.value);
    this.containers = combined.map(item => item.coordinates);
    this.tags = combined.map(item => item.data);

    for (const i in this.indices) {
      this.segments.push(
        this.path_points.slice(
          this.indices[i - 1]
          ?? 0, this.indices[i] + 1
        )
      )
    }
  }

  drawPath() {
    const options = {
      weight: this.path_weight,
      fillOpacity: this.opacity,
      opacity: this.opacity,
      color: this.path_color,
      lineCap: "square"
    }

    const start = require('@/assets/icons/flag-start.png')
    const end = require('@/assets/icons/man-end.png')

    const s = L.marker(this.path_points[0], {icon: this.getIcon(start)})
    const e = L.marker(this.path_points[this.path_points.length - 1], {icon: this.getIcon(end)})

    this.pathGroup.addLayer(s)
    this.pathGroup.addLayer(e)

    this.routeLine = L.polyline(this.path_points, options)
    this.pathGroup.addLayer(this.routeLine)

  }

  getIcon(img) {
    return L.divIcon({
      html: L.Util.template(`<img style="width: 20px" src="${img}" alt="">`),
      iconSize    : [20, 30], })
  }


  getBounds() {
    return this.routeLine.getBounds()
  }

  containerProjection(point) {
    const { nearestPoint, index } = RouteHelper.getProjectionPoint(this.path_points, point)
    if (!nearestPoint) return false
    let exist = this.path_points.some(item => item[0] === nearestPoint[0] && item[1] === nearestPoint[1]);
    if (!exist) {
      this.path_points.splice(index + 1,0, nearestPoint)
    }
    return index + 1
  }

  initLinePointPopup = p => {
    const pop = new this.linePointInfo({
      propsData: {
        data: {
          ...this.initPopup,
          lifted: this.green_indices.length,
          percent: this.getPercent(),
          tag: p.tag,
          code: p.code,
          lastupdate: p.lastupdate,
        }
      }
    })

    pop.$mount()
    return pop.$el
  }

  createContainers(container) {
    let c = L.circleMarker(container, { ...this.containerCircleOptions, color: '#a91f0d', pane:'circles'})
    c.bindPopup('', { closeButton: false,})
    this.containersGroup.addLayer(c)
    return c
  }

  hide() {
    this.map.removeLayer(this.pathGroup)
  }

  show() {
    this.pathGroup.addTo(this.map)
  }

  fitOnContainer(tag) {
    const i = this.tags.findIndex(item => item.tag === tag)
    if (i === -1) return

    this.map.flyTo(this.containers[i])

    if (!this.selectedContainerFit) {
      this.selectedContainerFit = L.marker(this.containers[i], { icon:
          L.divIcon({ className: 'pulse', iconSize: [15, 15] }) }).addTo(this.map);

      (function(ms, me) {
        setTimeout(function() {
            me.map.removeLayer(me.selectedContainerFit)
            me.selectedContainerFit = null
          }, ms
        );
      })(5000, this)
    }
    else {
      this.selectedContainerFit.setLatLng(this.containers[i])
    }

  }

  getPercent() {
    return ((this.green_indices.length / this.indices.length) * 100).toFixed(2)
  }

  getTableRow() {
    return {
      id: this.initPopup.id,
      name: this.initPopup.path,
      device: this.initPopup.device,
      contract: this.initPopup.contract,
      containers: this.indices.length,
      lifted: this.green_indices.length,
      percent: this.getPercent(),
      lastupdate: ""
    }
  }

}